import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RhynothonHttpService {
  
  constructor(private http: HttpClient) {}

  /**
   * Busca dados do Rhynothon por hash
   */
  getRhynothonByHash(hashRhynothon: string): Observable<any> {
    return this.http.get(`${environment.backend}/rhynothon/widget/${hashRhynothon}`);
  }
}